class Modal
{
  // ---------------------------------------------------------------------------------------------------------
	// --	Modal
	// ---------------------------------------------------------------------------------------------------------

  constructor()
  {
    console.log('Modal')

    //DOM参照
    this.modal = $('.sc-modal')
    this.panel = $('.sc-modal__panel')
    this.container = $('.sc-modal__container')
    this.closeBtn = $('.sc-modal__close-btn')

    //閉じるボタン
    this.closeBtn.click(this.closeModal.bind(this))

    //モーダルボタン
    const holder = this
    $('.js-modal-btn').click(function(e){
      e.preventDefault()
      const tag = $(this).attr('href').split('#')[1]
      holder.showModal(tag)
    })

    //リサイズハンドリング
    $(window).resize(this.onResize.bind(this))

    //リセット
    this.reset()
  }

  reset()
  {
    this.isVisible = false
    this.modal.css('display', 'none')

    //コンテナ空に
    this.container.empty()
    this.container.animate({scrollTop: 0}, 100)
    this.container.css('height', 'auto')
  }

  showModal(tag)
  {
    //フラグ
    this.isVisible = true

    //スクロール停止
    $('html, body').css('overflow-y', 'hidden')
    
    //コンテンツいれる
    const cloned = $('.'+tag).find('.sc-modal__wrapper').clone()
    this.container.append(cloned)

    //表示
    gsap.set(this.modal, {alpha:0})
    gsap.set(this.panel, {alpha:0, scaleX:0.9, scaleY:0.9})
    this.modal.css('display', 'flex')

    //リサイズ
    gsap.delayedCall(0.1, () => {
      this.onResize()
    })

    //アニメーション
    gsap.to(this.modal, 0.3, {
      alpha:1,
      ease:'none',
      delay:0.1
    })
    gsap.to(this.panel, 0.3, {
      alpha:1,
      ease:'none',
      delay:0.4
    })
    gsap.to(this.panel, 0.6, {
      scaleX:1,
      scaleY:1,
      ease:'back.out(1.7)',
      delay:0.4
    })
  }

  closeModal(e)
  {
    e.preventDefault()

    //スクロール再開
    $('html, body').css('overflow-y', 'auto')

    gsap.killTweensOf(this.modal)
    gsap.killTweensOf(this.panel)

    gsap.to(this.modal, 0.1, {
      alpha:0,
      ease:'none',
      onComplete:this.reset.bind(this)
    })
  }

  onResize()
  {
    if(!this.isVisible) return
    this.container.css('height', this.panel.height() + 'px')
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default Modal
